import {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { useSession } from "next-auth/react";
import {
  Text,
  Button,
  Center,
  Box,
  useColorModeValue,
  Image,
  Link,
  Tooltip,
  Checkbox,
  useDisclosure,
  Flex,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Tag,
} from "@chakra-ui/react";
import { AiOutlineDelete, AiOutlineMail, AiOutlineClear } from "react-icons/ai";
import { MdAlternateEmail } from "react-icons/md";
import { FiLink } from "react-icons/fi";
import { AddIcon } from "@chakra-ui/icons";
import { Table, Thead, Tbody, Tr, Th, Td, chakra } from "@chakra-ui/react";
import { QuestionIcon } from "@chakra-ui/icons";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import {
  useTable,
  useSortBy,
  useRowSelect,
  useBlockLayout,
  useFilters,
} from "react-table";
import PuffLoader from "react-spinners/PuffLoader";
import toast from "react-hot-toast";
import { useRouter } from "next/router";
import { FixedSizeList } from "react-window";
import { getAccount, updateUser } from "utils/sessionHelper";
import { useFirebaseUser } from "utils/useFirebaseUser";
import { Actions } from "./actions";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { PushLemlistPopup } from "components/popups/pushLemlistPopup";
import {
  addRemovePeopleToList,
  enrich,
  getContacts,
  countContacts,
} from "controllers/list";
import { GetEmailButton } from "./get-email-button";
import { GetIcebreakerButton } from "./get-icebreaker-button";
import { useMiscellaneousContext } from "context/miscellaneousContext";
import { DownloadIcon } from "@chakra-ui/icons";
import { CSVLink } from "react-csv";
import { useTweetContext } from "context/tweetContext";
import { MainContext } from "../../context/mainContext";
import AutoSizer from "react-virtualized-auto-sizer";
import { MatchString, NumberRangeFilter } from "components/react-table/filters";
import { FiFilter } from "react-icons/fi";
import * as Bowser from "bowser";
import { getDateFromSecondsAndNanoSeconds, roundUp } from "utils/helpers";
import { FaExchangeAlt } from "react-icons/fa";
import { MoveListPopup } from "./MoveListPopup";
import { color, layerStyle, radius, textStyle, variant } from "theme/names";
import { ContactList } from "types/contactList";
import { formatDistance } from "date-fns";
import { sortLastInteractionDates } from "./utils";
import { getPlan } from "../../controllers/subscription";
import { isFeatureEnabled } from "utils/helpers";
interface Props {
  ctaAddPeople?: () => void;
  listId?: number | undefined;
  list?: {
    id?: string;
    name?: string;
    isLikers: boolean;
    isRepliers: boolean;
    isAddAutoLemlist?: boolean;
    idLemlistCampaign?: string;
    nameLemlistCampaign?: string;
  };
  pageNo?: number;
  contactLimits?: number;
  selectedListName?: string;
  setContactsLength?: React.Dispatch<React.SetStateAction<number>>;
  refresh?: any;
  openCreateList?: any;
  inputContacts?: ContactList[];
  isSearchDatabase?: boolean;
}

export const headers = [
  { label: "Username", key: "username" },
  { label: "First Name", key: "firstName" },
  { label: "Last Name", key: "lastName" },
  { label: "Email", key: "emails" },
  { label: "Icebreaker", key: "icebreaker" },
  { label: "image", key: "image" },
  { label: "position", key: "position" },
  { label: "location", key: "location" },
  { label: "company", key: "company" },
  // { label: "twitter", key: "twitter" },
  { label: "linkedin", key: "profileUrl" },
  { label: "Bio", key: "bio" },
  { label: "Followers", key: "followersCount" },
  // { label: "Connections", key: "connectionCount" },
  { label: "# replies received", key: "nbRepliesReceived" },
  { label: "# likes received", key: "nbLikesReceived" },
  { label: "Company tags", key: "companyIndustryTags" },
  { label: "ID", key: "id" },
  // { label: "IdLinkedIn", key: "idLinkedin" },
];

export function ListTable({
  ctaAddPeople = () => {},
  listId = -1,
  list = undefined,
  refresh,
  setContactsLength = () => {},
  selectedListName = "",
  openCreateList = () => {},
  inputContacts = [],
  isSearchDatabase = false,
  pageNo = 1,
  contactLimits = -1,
}: Props) {
  const [contacts, setContacts] = useState<ContactList[]>([]);
  const [allContacts, setAllContacts] = useState<ContactList[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableRefresh, tableRefresher] = useState({});
  const [columnRefresh, columnRefresher] = useState({});
  const [isFindingEmails, setIsFindingEmails] = useState<boolean>(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenMoveList,
    onOpen: onOpenMoveList,
    onClose: onCloseMoveList,
  } = useDisclosure();
  const {
    isOpen: isOpenLemlistPopup,
    onOpen: onOpenLemlistPopup,
    onClose: onCloseLemlistPopup,
  } = useDisclosure();
  const {
    isOpen: isOpenLemlistExplorePopup,
    onOpen: onOpenLemlistExplorePopup,
    onClose: onCloseLemlistExplorePopup,
  } = useDisclosure();
  const { data: session } = useSession() ?? {};
  const isAuthenticated = useFirebaseUser();
  const miscellaneousContext: any = useMiscellaneousContext();
  const router = useRouter();
  const csvLink = useRef(null);
  const tweetContext: any = useTweetContext();
  const mainContext = useContext<any>(MainContext);
  const handleFilterRef = useRef(null);
  const nameFilterRef = useRef(null);
  const bioRef = useRef(null);
  const companyRef = useRef(null);
  const positionRef = useRef(null);
  const nbDmSentRef = useRef(null);
  const nbLikesReceivedRef = useRef(null);
  const nbRepliesReceivedRef = useRef(null);
  const followersRef = useRef(null);
  const followingRef = useRef(null);
  const locationRef = useRef(null);
  const paginationCursor = useRef(new Map());

  const blue50 = useColorModeValue("blue.50", "whiteAlpha.100");
  // const gray100 = useColorModeValue("gray.100", "gray.700");
  // const gray = useColorModeValue("gray", "gray.400");
  // const blue700 = useColorModeValue("blue.700", "blue.200");

  const transformContactsData = (contact) => {
    let nbLikes = contact.nbLikesReceived ?? 0;
    let nbReplies = contact.nbRepliesReceived ?? 0;
    let formatLastInteractionDate = "-";
    //if for when the object is present but doesn't have seconds or nanoseconds.
    if (
      contact?.lastInteractionDate &&
      !isNaN(contact?.lastInteractionDate?.seconds) &&
      !isNaN(contact.lastInteractionDate.nanoseconds)
    ) {
      const formatDateToDistance = formatDistance(
        getDateFromSecondsAndNanoSeconds(
          contact.lastInteractionDate.seconds,
          contact.lastInteractionDate.nanoseconds
        ),
        new Date()
      );
      formatLastInteractionDate = `${formatDateToDistance} ago`;
    }

    return {
      ...contact,
      name: contact.name ?? [contact.firstName, contact.lastName].join(" "),
      location: contact?.location?.default,
      followersCount: contact?.followersCount ?? 0, //0 can mean NaN or undefined since cell is numeric
      nbDmSent: contact.nbDmSent ?? 0,
      nbLikesReceived: contact.nbLikesReceived ?? 0,
      nbLikesAndCommentReceived: nbLikes + nbReplies,
      nbRepliesReceived: contact.nbRepliesReceived ?? 0,
      lastInteractionDateString: formatLastInteractionDate, //preserve lastInteractionDate for sort - manoj
      actions: { contact: contact, listId, refresher: tableRefresher },
    };
  };

  const filterDeletedContacts = (contact) => {
    return Boolean(contact?.deleted !== true);
  };

  const data = useMemo(() => {
    return allContacts.filter(filterDeletedContacts).map(transformContactsData);
  }, [allContacts]);

  const csvData = useMemo(async () => {
    const allContacts = await getContacts(getAccount(session)?.id, listId);
    return allContacts.filter(filterDeletedContacts).map(transformContactsData);
  }, [session, listId]);

  useEffect(() => {
    csvData.then((csvAll) => setAllContacts(csvAll));
  }, [csvData]);

  useEffect(() => {
    if (inputContacts.length > 0) {
      setContacts(inputContacts.filter(filterDeletedContacts));
      setAllContacts(inputContacts.filter(filterDeletedContacts));
    }
  }, [inputContacts]);

  useEffect(() => {
    console.log(
      "get contacts for list: " + listId + " with page No: " + pageNo
    );
    const getList = async () => {
      try {
        if (listId === undefined) {
          return;
        }

        setIsLoading(true);
        const people = await getContacts(
          getAccount(session)?.id,
          listId,
          contactLimits,
          pageNo,
          paginationCursor
        );

        const peopleCount: number = await countContacts(
          getAccount(session)?.id,
          listId
        );

        if (people) {
          let newContacts = people.map((p) => {
            return {
              ...p,
              position:
                p?.zFull?.position_groups?.[0]?.profile_positions?.[0]?.title,
              company: p?.zFull?.position_groups?.[0]?.company?.name,
              linkedin: "https://www.linkedin.com/in/" + p?.username,
              bio: `${p?.summary?.replace(/"/g, "\\")}`,
            };
          });
          setContacts(newContacts);
          setAllContacts(prevContacts => {
            const existingContacts = prevContacts.filter(contact =>
              !newContacts.some(newContact => newContact.id === contact.id)
            );
            return [...existingContacts, ...newContacts];
          });
          setContactsLength(peopleCount);
        }
      } catch (err) {
        console.log("Error in fetching contacts: ", err);
        toast.error("Error in fetching contacts: " + err.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (isAuthenticated) {
      getList();
    }
  }, [listId, refresh, isAuthenticated, tableRefresh, pageNo]);

  let columns = [
    {
      Header: "",
      accessor: "image",
      disableSortBy: true,
      width: 80,
      disableFilters: true,
      Cell: ({ value }) => (
        <Box>
          <Image
            src={value}
            alt="profile image"
            h="10"
            w="10"
            mx="auto"
            borderRadius="50%"
            maxW="unset"
            fallbackSrc="/emptyProfile.png"
            fallbackStrategy="onError"
          />
        </Box>
      ),
    },
    {
      Header: "Username",
      accessor: "username",
      tooltipText: "Username",
      disableSortBy: true,
      width: 125,
      Filter: (props) => (
        <MatchString
          {...props}
          ref={handleFilterRef}
          placeholder="Search handle..."
        />
      ),
      filterRef: handleFilterRef,
      Cell: ({ value }) => (
        <Link href={"https://www.linkedin.com/in/" + value} isExternal>
          <Text
            textStyle={textStyle["body.medium.light"]}
            // color={gray}
            textAlign="start"
            noOfLines={1}
            wordBreak={"break-all"}
          >
            {value}
          </Text>
        </Link>
      ),
    },
    {
      Header: "name",
      accessor: "name",
      tooltipText: "Name",
      sortDescFirst: true,
      width: 125,
      Filter: (props) => (
        <MatchString
          {...props}
          ref={nameFilterRef}
          placeholder="Search name..."
        />
      ),
      filterRef: nameFilterRef,
      Cell: ({ value }) => (
        <Text
          textStyle={textStyle["body.medium.light"]}
          fontWeight="500"
          maxW={value ? "32" : "auto"}
          // w={"30"}
          mr="2"
          noOfLines={1}
          wordBreak={"break-all"}
          textAlign="start"
        >
          {value}
        </Text>
      ),
    },
    {
      Header: "email",
      accessor: "emails",
      tooltipText: "Email",
      disableSortBy: true,
      width: 125,
      disableFilters: true,
      Cell: ({ value, row }) => (
        <GetEmailButton
          session={session}
          contacts={contacts}
          data={data}
          row={row}
          value={value}
          columnRefresher={columnRefresher}
        />
      ),
    },
    {
      Header: "icebreaker",
      accessor: "icebreaker",
      tooltipText: "Icebreaker",
      disableSortBy: true,
      width: 150,
      disableFilters: true,
      Cell: ({ value, row }) => (
        <GetIcebreakerButton
          session={session}
          contacts={contacts}
          data={data}
          row={row}
          value={value}
          columnRefresher={columnRefresher}
        />
      ),
    },
    // {
    //   Header: "Bio",
    //   accessor: "summary",
    //   tooltipText: "Bio",
    //   disableSortBy: true,
    //   width: 180,
    //   Filter: (props) => (
    //     <MatchString {...props} ref={bioRef} placeholder="Search bio..." />
    //   ),
    //   filterRef: bioRef,
    //   Cell: ({ value }) => (
    //     <Text textStyle={textStyle["body.medium.light"]}
    //       fontSize={value ? "md" : "xs"}
    //       maxW={value ? "150px" : "auto"}
    //       noOfLines={1} wordBreak={"break-all"}
    //       textAlign="start"
    //     >
    //       {value ? value : "N/A"}
    //     </Text>
    //   ),
    // },
    {
      Header: "Company",
      accessor: "zFull.position_groups[0].company.name",
      tooltipText: "Current Company",
      disableSortBy: true,
      width: 150,
      Filter: (props) => (
        <MatchString
          {...props}
          ref={companyRef}
          placeholder="Search company..."
        />
      ),
      filterRef: companyRef,
      Cell: ({ value, row }) => {
        return (
          <Text
            textStyle={textStyle["body.medium.light"]}
            // fontSize={"md"}
            maxW={value ? "200px" : "auto"}
            noOfLines={1}
            wordBreak={"break-all"}
            textAlign="start"
          >
            {value ? value : "N/A"}
          </Text>
        );
      },
    },
    {
      Header: "Position",
      accessor: "position",
      tooltipText: "Current Position",
      disableSortBy: true,
      width: 125,
      Filter: (props) => (
        <MatchString
          {...props}
          ref={positionRef}
          placeholder="Search Position..."
        />
      ),
      filterRef: positionRef,
      Cell: ({ row }) => {
        // console.log(row);
        // console.log(row.original?.zFull);
        let value =
          row.original?.zFull?.position_groups?.length > 0 &&
          row.original?.zFull?.position_groups[0]?.profile_positions?.length > 0
            ? row.original?.zFull?.position_groups[0]?.profile_positions[0]
                ?.title
            : null;
        return (
          <Text
            textStyle={textStyle["body.medium.light"]}
            // fontSize="md"
            maxW={value ? "32" : "auto"}
            noOfLines={1}
            wordBreak={"break-all"}
            textAlign="start"
          >
            {value ?? "N/A"}
          </Text>
        );
      },
    },
    {
      Header: "Location",
      accessor: "location",
      tooltipText: "Location",
      disableSortBy: true,
      width: 180,
      Filter: (props) => (
        <MatchString
          {...props}
          ref={locationRef}
          placeholder="Search location..."
        />
      ),
      filterRef: locationRef,
      Cell: ({ value }) => {
        return (
          <Text
            textStyle={textStyle["body.medium.light"]}
            maxW={value ? "40" : "auto"}
            noOfLines={1}
            wordBreak={"break-all"}
            textAlign="start"
          >
            {value ?? "N/A"}
          </Text>
        );
      },
    },
    {
      Header: ({ value }) => (
        <Text pl={0} textAlign="left">
          FOLLOWERS
        </Text>
      ),
      accessor: "followersCount",
      tooltipText: "No. of Followers",
      sortDescFirst: true,
      isNumeric: true,
      Filter: (props) => <NumberRangeFilter {...props} ref={followersRef} />,
      width: 140,
      filterRef: followersRef,
      filter: "between",
      Cell: ({ value }) => <Text textAlign="center">{roundUp(value)}</Text>,
    },
  ];

  const extraColumnsForContacts = [
    {
      Header: "DM sent",
      accessor: "nbDmSent",
      tooltipText: "Number of DM already sent",
      width: 100,
      sortDescFirst: true,
      isNumeric: true,
      Filter: (props) => <NumberRangeFilter {...props} ref={nbDmSentRef} />,
      filterRef: nbDmSentRef,
      filter: "between",
      Cell: ({ value, row }) => (
        <Text
          textStyle={textStyle["body.medium.light"]}
          fontSize={"sm"}
          noOfLines={1}
          wordBreak={"break-all"}
          textAlign="center"
        >
          {value ?? 0}
        </Text>
      ),
    },
    {
      Header: ({ value }) => (
        <Text pl={4} textAlign="left">
          LIKES & COMMENTS
        </Text>
      ),
      // Header: "Comment received",
      accessor: "nbLikesAndCommentReceived",
      tooltipText: "Number of comment and replies received by this user",
      width: 140,
      sortDescFirst: true,
      isNumeric: true,
      Filter: (props) => (
        <NumberRangeFilter {...props} ref={nbRepliesReceivedRef} />
      ),
      filterRef: nbRepliesReceivedRef,
      filter: "between",
      Cell: ({ value, row }) => (
        <Text
          textStyle={textStyle["body.medium.light"]}
          fontSize={"sm"}
          noOfLines={1}
          wordBreak={"break-all"}
          textAlign="center"
        >
          {value ?? 0}
        </Text>
      ),
    },
    {
      Header: ({ value }) => (
        <Text pl={4} textAlign="left">
          Last Interaction
        </Text>
      ),
      // Header: "Comment received",
      accessor: "lastInteractionDateString",
      tooltipText: "Date of the lastInteraction you had with this user",
      width: 120,
      disableFilters: true,
      sortType: sortLastInteractionDates,
      Cell: ({ value, row }) => (
        <>
          {row.original.lastInteractionUrl ? (
            <Link href={row.original.lastInteractionUrl} isExternal>
              <Text
                textStyle={textStyle["body.medium.light"]}
                fontSize={"sm"}
                noOfLines={1}
                wordBreak={"break-all"}
                textAlign="center"
              >
                {value}
              </Text>
            </Link>
          ) : (
            <Text
              textStyle={textStyle["body.medium.light"]}
              fontSize={"sm"}
              noOfLines={1}
              wordBreak={"break-all"}
              textAlign="center"
            >
              {value}
            </Text>
          )}
        </>
      ),
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      width: 100,
      disableFilters: true,
      Cell: ({ value, row }) => (
        <Actions
          value={value}
          row={row}
        />
      ),
    },
  ] as any;

  const extraColumnsForSearchDatabase = [
    {
      Header: "Industry Tags",
      accessor: "companyIndustryTags",
      tooltipText: "Number of DM already sent",
      width: 500,
      // Filter: (props) => <NumberRangeFilter {...props} ref={nbDmSentRef} />,
      // filterRef: nbDmSentRef,
      // filter: "between",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ value, row }) => {
        return (
          <Flex w="500px" wrap="wrap">
            {value?.slice(0, 10)?.map((tag: any) => (
              <Tag
                maxW="80px"
                noOfLines={1}
                wordBreak={"break-all"}
                size="xs"
                variant="outline"
                fontSize="xs"
                key={tag}
                p={1}
                m={"2px"}
                colorScheme="blue"
              >
                {tag}
              </Tag>
            ))}
          </Flex>
        );
      },
    },
  ] as any;

  if (!isSearchDatabase) {
    columns = useMemo(
      () => [...columns, ...extraColumnsForContacts],
      [columnRefresh]
    );
  } else {
    columns = useMemo(
      () => [...columns, ...extraColumnsForSearchDatabase],
      [columnRefresh]
    );
  }

  const defaultColumn = useMemo(
    () => ({
      width: 90,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    totalColumnsWidth,
    setAllFilters,
    toggleAllRowsSelected,
    state,
    initialState,
  } = useTable(
    { columns, data, defaultColumn },
    useFilters,
    useSortBy,
    useBlockLayout,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          Header: ({ getToggleAllRowsSelectedProps }) => {
            const props = {
              ...getToggleAllRowsSelectedProps({ title: undefined }),
            };
            delete props.indeterminate;
            return (
              <Tooltip label="Select All">
                <span>
                  <Checkbox isChecked={props.checked} {...props} />
                </span>
              </Tooltip>
            );
          },
          Cell: ({ row }) => {
            const props = {
              ...row.getToggleRowSelectedProps({ title: undefined }),
            };
            delete props.indeterminate;
            return (
              <Tooltip label="Select">
                <span onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    isChecked={props.checked}
                    title="Select"
                    {...props}
                  />
                </span>
              </Tooltip>
            );
          },
          width: 25,
        },
        ...columns,
      ]);
    }
  );

  useEffect(() => {
    if (router.query) {
      initialState.filters = [];

      for (const key in router.query) {
        if (Array.isArray(router.query[key])) {
          // Map is having an error because it says router.query[key] is a string while i checked if it was an array
          // @ts-ignore
          const formatToInt = router.query[key]?.map((queryValue) =>
            queryValue ? parseInt(queryValue) : ""
          );

          initialState.filters.push({ id: key, value: formatToInt });
        } else {
          initialState.filters.push({ id: key, value: router.query[key] });
        }
      }
    }
  }, []);

  useEffect(() => {
    let pathname = router.pathname;
    // console.log('filters:', state.filters);
    if (state.filters.length !== 0) {
      const newFilters = state.filters.reduce((acc, { id, value }) => {
        acc[id] = value;
        return acc;
      }, {});

      router.replace({ pathname, query: { ...newFilters, page: pageNo } });
    }
  }, [state.filters]);

  const selectedPeople = selectedFlatRows?.map((s) => {
    delete s.original?.actions;
    return s.original;
  });

  const handleMultipleDelete = async () => {
    try {
      if (listId === undefined) {
        return;
      }

      await addRemovePeopleToList(
        getAccount(session)?.id,
        listId,
        selectedPeople,
        "remove"
      );

      toast.success(`Successfully removed from the list`);
      tableRefresher({});
    } catch (err) {
      console.log("Error in removing person from the list: ", err);
      toast.error("Error in removing person from the list: " + err.message);
    }
  };

  const RenderRow = useCallback(
    ({ index, style }) => {
      const row = rows[index];
      prepareRow(row);
      return (
        <Tr
          as={Box}
          {...row.getRowProps({ style })}
          cursor="pointer"
          _hover={{
            background: blue50,
          }}
          px="3"
          onClick={() => {
            tweetContext.setIsOpen(false);
            miscellaneousContext.setSidebarPerson(row.original);
            miscellaneousContext.setIsPersonSidebarOpen(true);
          }}
          alignItems="center"
        >
          {row.cells.map((cell) => (
            <Td
              {...cell.getCellProps()}
              as={Box}
              textAlign="center"
              paddingX="1"
              borderBottom="none"
            >
              {cell.render("Cell")}
            </Td>
          ))}
        </Tr>
      );
    },
    [prepareRow, rows, selectedFlatRows]
  );

  let safariStyles = {};
  if (typeof window !== "undefined") {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isSafari = browser?.getBrowserName()?.includes("Safari");

    if (isSafari) {
      safariStyles = {
        display: "block",
        overflow: "auto",
      };
    }
  }

  // console.log('safariStyles:', safariStyles);
  // console.log('columns:', columns);
  // console.log('defaultColumn:', defaultColumn);
  // console.log('data:', data);

  return (
    <Box>
      <Box mt="8">
        <Box>
          {list?.isLikers && (
            <Text textStyle={textStyle["body.medium.light"]}>
              <QuestionIcon
                mb={0.5}
                color={color["text.lightMode.light"]}
                mr={2}
              />
              This list is automatically filled with people who like your posts
            </Text>
          )}
          {list?.isRepliers && (
            <Text textStyle={textStyle["body.medium.light"]}>
              <QuestionIcon
                mb={0.5}
                color={color["text.lightMode.light"]}
                mr={2}
              />
              This list is automatically filled with people who comment your
              posts
            </Text>
          )}
        </Box>
        {contacts?.length > 0 && (
          <Flex
            justifyContent="end"
            flexWrap="wrap"
            gap="12px"
            alignItems="center"
            mt="3"
          >
            {selectedFlatRows.length > 0 && (
              <Flex
                justifyContent="end"
                flexWrap="wrap"
                gap="12px"
                alignItems="center"
              >
                <Text
                  textStyle={textStyle["body.medium.light"]}
                  as="i"
                  fontSize="xs"
                  fontWeight="bold"
                >
                  {selectedFlatRows.length} selected
                </Text>
                <Button
                  variant="secondary"
                  leftIcon={<MdAlternateEmail height={3} width={3} />}
                  isDisabled={isFindingEmails}
                  isLoading={isFindingEmails}
                  onClick={async () => {
                    try {
                      if (!getPlan(session?.user).includes("enterprise")) {
                        mainContext.onOpenUpgrade();
                        return;
                      }
                      setIsFindingEmails(true);
                      await enrich(
                        session,
                        selectedPeople,
                        contacts,
                        setContacts,
                        data,
                        undefined,
                        mainContext,
                        undefined,
                        columnRefresher
                      );
                    } catch (err) {
                      console.log("Error", err);
                    } finally {
                      setIsFindingEmails(false);
                    }
                  }}
                >
                  Get Emails
                </Button>
                <Button
                  variant="secondary"
                  leftIcon={<FaExchangeAlt size={10} />}
                  onClick={() => {
                    let contactLists = getAccount(session)?.contactLists || [];
                    contactLists = contactLists.filter(
                      (c) => !(c.isSubscribers || c.isSupporters)
                    );

                    if (contactLists.length < 2) {
                      toast.error("You don't have any other list to move to");
                    } else {
                      onOpenMoveList();
                    }
                  }}
                >
                  Move contacts
                </Button>
                <Button
                  variant="secondary"
                  leftIcon={<AddIcon h="3" w="3" />}
                  onClick={() => {
                    miscellaneousContext.setNewListMembers(selectedPeople);
                    openCreateList();
                  }}
                >
                  New List
                </Button>
                <Button
                  variant={variant.Button.secondaryDestructive}
                  leftIcon={<AiOutlineDelete height={3} width={3} />}
                  onClick={onOpen}
                >
                  Delete
                </Button>
                {isFeatureEnabled("outreach", session, {}, false, "") && (
                  <Button
                    variant={variant.Button.secondary}
                    leftIcon={<AiOutlineMail height={3} width={3} />}
                    onClick={() => {
                      miscellaneousContext.setCrmDm(selectedPeople);
                      router.push(
                        { pathname: "/dm", query: { from: "crm" } },
                        "/dm"
                      );
                    }}
                  >
                    Send a DM
                  </Button>
                )}
              </Flex>
            )}
            {state?.filters?.length > 0 && (
              <Button
                // size="sm"
                onClick={() => {
                  setAllFilters([]);
                  toggleAllRowsSelected(false);
                }}
                variant="secondary"
                rightIcon={<AiOutlineClear />}
              >
                Reset Filters
              </Button>
            )}
            <Button
              variant="primary"
              leftIcon={<FiLink height={3} width={3} />}
              onClick={() => {
                if (getAccount(session)?.keyLemlist) onOpenLemlistPopup();
                else onOpenLemlistExplorePopup();
              }}
            >
              Push to lemlist
            </Button>
            <CSVLink
              data={selectedFlatRows.length > 0 ? selectedPeople : allContacts}
              headers={headers}
              filename={selectedListName + "_export.csv"}
              className="hidden"
              ref={csvLink}
              target="_blank"
            >
              <Button variant="primary" leftIcon={<DownloadIcon h="3" w="3" />}>
                Export CSV
              </Button>
            </CSVLink>
          </Flex>
        )}
        {list?.isAddAutoLemlist && (
          <Flex justifyContent="flex-end">
            <Tag
              size="sm"
              variant="outline"
              rounded="lg"
              colorScheme="blue"
              pl={4}
              mt={4}
            >
              New contacts in this leads will be automatically send to the
              lemlist campaign '<b>{list.nameLemlistCampaign}</b>'
              <Button
                // size="xs"
                variant="actionDestructive"
                m={1}
                mr={-1}
                ml={2}
                onClick={async () => {
                  toast.promise(
                    new Promise(async (resolve, reject) => {
                      let listOnUser = getAccount(session)?.contactLists?.find(
                        (l: any) => l.id === list.id
                      );
                      if (listOnUser) {
                        listOnUser.isAddAutoLemlist = false;
                        listOnUser.idLemlistCampaign = "";
                        listOnUser.nameLemlistCampaign = "";
                        await updateUser(session, {
                          contactLists: getAccount(session)?.contactLists,
                        });
                        tableRefresher({});
                        resolve(listOnUser);
                      } else {
                        reject("list not found");
                      }
                    }),
                    {
                      loading: "removing automation",
                      success: "lemlist automation disabled",
                      error: "An error happened",
                    }
                  );
                }}
              >
                remove
              </Button>
            </Tag>
          </Flex>
        )}
      </Box>

      <Box
        mt="6"
        overflow="auto"
        minH="96"
        layerStyle={layerStyle["bg.border.rounded"]}
        borderRadius={radius.lg}
      >
        <Table
          as={Box}
          {...getTableProps()}
          css={{ borderCollapse: "separate" }}
          variant={"simpleNoBg"}
        >
          <Thead as={Box}>
            {headerGroups.map((headerGroup) => (
              <Tr {...headerGroup.getHeaderGroupProps()} px="3" as={Box}>
                {headerGroup.headers.map((column, index) => (
                  <Th {...column.getHeaderProps()} paddingX="1" as={Box}>
                    <Flex alignItems="center" h="100%">
                      <Box
                        {...column.getSortByToggleProps({ title: undefined })}
                      >
                        {column.render("Header")}
                      </Box>
                      {column.canFilter ? (
                        <Popover initialFocusRef={column.filterRef}>
                          <PopoverTrigger>
                            <Box cursor="pointer">
                              <chakra.span>
                                <Icon as={FiFilter} ml="2" />
                              </chakra.span>
                            </Box>
                          </PopoverTrigger>
                          <PopoverContent>
                            <PopoverArrow />
                            <PopoverBody p="4">
                              {column.render("Filter")}
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      ) : null}
                      {column.isSorted ? (
                        <chakra.span
                          pl="3"
                          {...column.getSortByToggleProps({ title: undefined })}
                        >
                          {column.isSortedDesc ? (
                            <TriangleDownIcon aria-label="sorted descending" />
                          ) : (
                            <TriangleUpIcon aria-label="sorted ascending" />
                          )}
                        </chakra.span>
                      ) : null}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody
            as={Box}
            {...getTableBodyProps()}
            height={!isLoading && rows.length > 0 ? "70vh" : "unset"}
            {...safariStyles}
          >
            <AutoSizer>
              {({ height }) =>
                rows.length > 0 && (
                  <FixedSizeList
                    height={height}
                    itemCount={rows.length}
                    itemSize={70}
                    width={totalColumnsWidth}
                  >
                    {RenderRow}
                  </FixedSizeList>
                )
              }
            </AutoSizer>
          </Tbody>
        </Table>
        {isLoading && (
          <Center h="100px" w="100%">
            <PuffLoader
              color={"#0A66C2"}
              loading={isLoading}
              cssOverride={{
                display: "block",
                margin: "0 auto",
                borderColor: "red",
              }}
              size={50}
            />
          </Center>
        )}
        {!isLoading &&
          contacts?.length === 0 &&
          (isSearchDatabase ? (
            <Center my={20}>
              No results found - launch a search to find new contacts
            </Center>
          ) : (
            <Box display="flex" justifyContent="center">
              <Center
                maxW="400px"
                my={20}
                display="flex"
                flexDirection="column"
              >
                <Text textStyle={textStyle["body.medium.light"]}>
                  Your list is empty.
                </Text>
                <Button
                  mt={5}
                  maxW="300px"
                  variant={"primary"}
                  onClick={ctaAddPeople}
                >
                  Add People to your list
                </Button>
              </Center>
            </Box>
          ))}
      </Box>
      {listId ? (
        <MoveListPopup
          isOpen={isOpenMoveList}
          onClose={onCloseMoveList}
          currentListId={listId}
          contacts={selectedPeople}
          onFinish={() => {
            tableRefresher({});
          }}
        />
      ) : null}
      <ConfirmPopup
        isOpen={isOpen}
        onClose={onClose}
        callback={handleMultipleDelete}
        title="Delete"
        body={
          selectedPeople.length === contacts.length ? (
            <>You are about to remove everyone from the list. Are you sure?</>
          ) : (
            <>
              You are about to remove{" "}
              <b>{selectedPeople.map((s) => s.name).join(", ")}</b> from the
              list
            </>
          )
        }
      />
      <ConfirmPopup
        isOpen={isOpenLemlistExplorePopup}
        onClose={onCloseLemlistExplorePopup}
        callback={() => {
          router.push("/settings?tab=integrations");
        }}
        cta="Add your lemlist key"
        title="Taplio x lemlist integration"
        body={
          <Box>
            <Text textStyle={textStyle["body.medium.light"]}>
              Turn your LinkedIn audience into nurtured leads and future clients
              with our lemlist integration.
            </Text>
            <Text textStyle={textStyle["body.medium.light"]} mt={4}>
              If you already have a lemlist account, copy your lemlist API key
              in the{" "}
              <Link
                href="/settings?tab=integrations"
                textDecoration="underline"
              >
                integration section
              </Link>{" "}
              and start adding your Taplio contacts to lemlist campaigns.
            </Text>
          </Box>
        }
      />
      <PushLemlistPopup
        leads={selectedPeople?.length > 0 ? selectedPeople : contacts}
        taplioListName={list?.name}
        isOpen={isOpenLemlistPopup}
        onClose={onCloseLemlistPopup}
        listSelected={list}
      />
    </Box>
  );
}
